import { useOrderSearchForm } from '@euler/app/flows/search/context';
import { FormGroup } from '@euler/components/form';
import { Input } from '@euler/components/form/Input';
import { memo } from 'react';

export const OrderNumberField = memo(() => {
  const { form } = useOrderSearchForm();

  return (
    <FormGroup label="订单号">
      <Input
        value={form.orderNo.value ?? ''}
        placeholder="按订单编号搜索"
        clearButtonMode="always"
        keyboardType="number-pad"
        onChangeText={form.orderNo.update}
      />
    </FormGroup>
  );
});
